import React from "react";
import PropTypes from "prop-types";
import { Alert } from "@opendate-app/setlist";

const PayoutSetupPendingBanner = ({ justListed }) => (
  <div style={{ marginBottom: 16 }}>
    <Alert
      color="warning"
      title="Payout setup pending"
      description={
        <span>
          {justListed
            ? "Set up payouts within 48 hours to keep any unsold tickets listed. "
            : "Set up payouts to keep any unsold tickets listed. "}
          You won't be paid for any sale until you do.{" "}
          <a href="/settings/payout">Set up payouts now</a>
        </span>
      }
    />
  </div>
);

PayoutSetupPendingBanner.propTypes = {
  justListed: PropTypes.bool,
};

PayoutSetupPendingBanner.defaultProps = {
  justListed: false,
};

export default PayoutSetupPendingBanner;
